import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../Services/axiosCommon";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Label } from "recharts";
import { useNavigate } from "react-router-dom";

const COLORS = ["#F59E0B", "#8B5CF6", "#10B981", "#F43F5E"];

function PrFromCustomer() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function getData() {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`/dashboard/PR-pending`);
      setData(res?.data || {});
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const pendingCount = data?.pending ?? data?.pendding ?? 0;
  // const todayApproved = data?.today_approved ?? data?.todayApproved ?? data?.approved_today ?? 0;
  const todayVerified = data?.today_verified ?? 0;
  const todayRejected = data?.today_declined ?? 0;

  const chartData = [
    { name: "Pending", value: pendingCount, status: "Pending" },
    { name: "Verified Today", value: todayVerified, status: "Verified" },
    // { name: "Approved Today", value: todayApproved, status: "Approved" },
    { name: "Rejected Today", value: todayRejected, status: "Rejected" },
  ].filter((entry) => entry.value > 0);

  const sumValue = chartData.reduce((sum, item) => sum + item.value, 0);

  const handleSliceClick = (status) => {
    const path = "/procurement/purchase-requests";
    navigate(path, { state: { approvalStatus: status } });
  };

  return (
    <div className="bg-gradient-to-b from-amber-50/30 to-white p-4 rounded-xl border border-gray-100 hover:border-amber-200 shadow-sm transition-all duration-300 flex flex-col justify-between">
      {/* Header */}
      <div className="flex items-center justify-between pb-2 border-b border-gray-100">
        <span className="text-xs font-semibold text-gray-700 tracking-wide">YPR (Customer Requests)</span>
        {/* <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200/50">
          Approval Stream
        </span> */}
      </div>

      {/* Donut Chart with Center Pending Count */}
      <div className="relative my-2 flex justify-center items-center h-28">
        {loading ? (
          <div className="w-16 h-16 rounded-full bg-gray-100 animate-pulse"></div>
        ) : sumValue > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={28}
                outerRadius={40}
                paddingAngle={4}
                dataKey="value"
                stroke="none"
                style={{ cursor: "pointer" }}
                onClick={(entry) => handleSliceClick(entry.status)}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
                {/* <Label
                  value={`${pendingCount}`}
                  position="center"
                  style={{ fontSize: "14px", fontWeight: "bold", fill: "#1F2937" }}
                /> */}
              </Pie>
              <Tooltip
                wrapperStyle={{ zIndex: 50 }}
                contentStyle={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  color: "#1F2937",
                  border: "1px solid #E5E7EB",
                  fontSize: "11px",
                  padding: "4px 8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
                itemStyle={{ color: "#374151" }}
                labelStyle={{ color: "#6B7280", fontWeight: 600 }}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="text-center text-gray-400 text-xs font-medium">0 Pending</div>
        )}

        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" style={{ zIndex: 0 }}>
          <span className="text-xs font-bold text-gray-900 mt-4">{pendingCount}</span>
          <span className="text-[8px] text-amber-600 font-bold uppercase">Pending</span>
        </div>
      </div>

      {/* Today's Same-Day Activity */}
      <div className="pt-2 border-t border-gray-100 space-y-1.5">
        <div className="flex items-center justify-between text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">
          <span>Today's Status</span>
        </div>

        <div className="grid grid-cols-2 gap-1.5 text-center">
          {/* Today Verified */}
          <div className="p-1.5 rounded-lg bg-purple-50/60 border border-purple-100/60 flex flex-col items-center">
            <span className="text-[9px] font-medium text-purple-700">Verified</span>
            <span className="text-xs font-bold text-purple-900">{todayVerified}</span>
          </div>

          {/* Today Approved */}
          {/* <div className="p-1.5 rounded-lg bg-emerald-50/60 border border-emerald-100/60 flex flex-col items-center">
            <span className="text-[9px] font-medium text-emerald-700">Approved</span>
            <span className="text-xs font-bold text-emerald-900">{todayApproved}</span>
          </div> */}

          {/* Today Rejected */}
          <div className="p-1.5 rounded-lg bg-rose-50/60 border border-rose-100/60 flex flex-col items-center">
            <span className="text-[9px] font-medium text-rose-700">Rejected</span>
            <span className="text-xs font-bold text-rose-900">{todayRejected}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrFromCustomer;
